import "@/user/common";
import React from "react";
import { createRoot } from "react-dom/client";
import PhotoGallery from "@/shared/components/photo_gallery/index";

const photoGallery = document.getElementById("photo-gallery");
const { photos } = photoGallery.dataset;
let categoryId = photoGallery.dataset.photo_gallery_category_id;
const categories = photoGallery.dataset.photo_gallery_categories;
const accentColor = photoGallery.dataset.accent_color;
if (!categoryId) {
  categoryId = null;
} else {
  categoryId = parseInt(categoryId, 10);
}
if (photoGallery) {
  const root = createRoot(photoGallery);
  root.render(
    <PhotoGallery
      categories={JSON.parse(categories)}
      categoryId={categoryId}
      photos={JSON.parse(photos)}
      accentColor={accentColor}
    />,
  );
}
